
import React, { useState,useRef } from 'react'
import * as locales from 'react-date-range/dist/locale';

const CarRenta = () => {



const constraintsRef = useRef(null)
const [letters, setLetters] = useState(1)
const [adult, setAdult] = useState(1)
const [boy, setBoy] = useState(0)
const [baby, setBaby] = useState(0)
const [calendar, setcalendar] = useState(false)
const [calendarTwo, setCalendarTwo] = useState(false)
const [typeT, setTypeT] = useState(0)
const [ciudadDropdown, setCiudadDropdown] = useState(false)
const [aeropuertoDropdown, setAeropuertoDropdown] = useState(false)
const [dated, setDated] = useState(null);
const [date, setDate] = useState(null);

const nameMapper = {

  de: 'German',
  enGB: 'English (United Kingdom)',
  enUS: 'English (United States)',
  es: 'Spanish',

};

const localeOptions = Object.keys(locales)
  .map(key => ({
    value: key,
    label: `${key} - ${nameMapper[key] || ''}`
  }))
  .filter(item => nameMapper[item.value]);

const [locale, setLocale] = useState('es');


const changeScreen = (e) => {
  setLetters(e)
}


const passengersCal = (e, tip, num) => {
  e.preventDefault()
  if (tip == 'ad') {
    if (num == -1 && adult == 0) {
      setAdult(0)
    } else {
      setAdult(adult + num)
    }

  } else if (tip == 'bo') {
    if (num == -1 && boy == 0) {
      setBoy(0)
    } else {
      setBoy(boy + num)
    }

  } else {
    if (num == -1 && baby == 0) {
      setBaby(0)
    } else {
      setBaby(baby + num)
    }
  }

}

  return{
   setCiudadDropdown,
   ciudadDropdown,
   setcalendar,
   calendar,
   dated,
   setDated,
   calendarTwo,
   setCalendarTwo,
   date,
   setDate,
   setLocale,
   locale,
   localeOptions,
   changeScreen,
   locales
  }

  
    
}

export default CarRenta


